<template>
  <div
    v-if="!logged"
    class="top"
  >
    <img
      class="bmat-background"
      src="@/assets/img/soundwave_bckg_green.png"
    >
    <div class="lock">
      <div class="col">
        <img
          class="logo"
          src="@/assets/img/soundsys@1x.png"
        >
      </div>

      <div class="lock-form col">
        <form @submit.prevent="">
          <b-tabs v-model="tabIndex" ref="tabs">
            <b-tab :title="$t('log_in') | capitalize">
              <Login/>
            </b-tab>
            <b-tab :title="$t('sign_up') | capitalize">
              <Signup/>
            </b-tab>
          </b-tabs>
        </form>
      </div>
      <div class="col" />
    </div>
  </div>
</template>


<style lang="scss">
/* New way of prioritization */
#bootstrap-overrides.active {
  /* 100+1=101 priority score, yay! */
  line-height: 1;
  color: inherit;
}

.top {
  padding-top: 5%;
}

.tabs {
  ul {
    padding-left: 0;
  }

  a {
    color: #0091ff;
    font-family: "CircularStd", sans-serif !important;
    font-size: 16px !important;
    font-weight: 300;
    line-height: 20px;
    text-align: center !important;
    margin: auto;
    border-style: none;
  }

  li[role="presentation"] {
    width: 50%;
    padding-left: 0 !important;
    background-color: #dadfea;
    border-style: none;
  }

  a.active {
    background-color: white !important ;
    border-top: 3px solid #0091ff !important;
    border-style: none;
  }
}
</style>



<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

ul > li {
  width: 50%;
  padding-left: 0 !important;
  background-color: #dadfea;
  border-style: none;
}
</style>


<script>
import Login from "@/components/Pages/Login/Login.vue"
import Signup from "@/components/Pages/Login/SignUp.vue"

export default {
  name: "Welcome",
  components: {
    Signup,
    Login
  },
  mounted () {
    let expiresAt = localStorage.getItem("expires_at")
    expiresAt && new Date().getTime() > expiresAt && this.$toasted.global.toast(this.$t("expired_session"))
  },
  data () {
    return {
      tabIndex: 0,
    }
  },
  computed: {
    logged () {
      return this.$store.getters["soundsys/isLogged"]
    },
  }
}
</script>
